<div class="app-footer">
    <div class="app-footer__inner">
        <div class="app-footer-left">
            <span class="ps-2">Copyright 2022 - Sagun Baakas</span>
        </div>
    </div>
</div>
